import videoThumbnail from '../../../assets/video-thumbnail.jpg';
import textThumbnail from '../../../assets/text-thumbnail.jpg';
import imageThumbnail from '../../../assets/no-photo.jpg';

export const defaultThumbnailWidth = 300;

export const MediaTypes = {
  IMAGE: 'image',
  VIDEO: 'video',
  TEXT: 'text',
  EMBED: 'embed',
};

export const MediaThumbnails = {
  image: imageThumbnail,
  video: videoThumbnail,
  text: textThumbnail,
};
